<template>
    <CloudFrontContainer
        :project="selectedProject"
        :month="selectedMonth"
    ></CloudFrontContainer>
</template>

<script>
import store from '@/store'
import CloudFrontStore from '@/modules/CloudFront/_store'
import CloudFrontContainer from '@/modules/CloudFront'
import { getCurrentInstance } from '@vue/composition-api'
import useSelectProjectAndGroup from '@/composables/useSelectProjectAndGroup'
import useSelectMonth from '@/composables/useSelectMonth'
const STORE_KEY = '$_cloudfront'

export default {
    components: {
        CloudFrontContainer
    },
    setup () {
        const vm = getCurrentInstance().proxy
        const store = vm.$store
        const {
            selectedGroup,
            selectedProject,
            selectGroup,
            setInitialAccountSelect
        } = useSelectProjectAndGroup()
        const {
            selectedMonth
        } = useSelectMonth()
        if (!selectedProject.value) {
            setInitialAccountSelect()
        }
        if (selectedGroup.value) {
            selectGroup(null)
        }
        store.dispatch(`${STORE_KEY}/getCloudFront`, {
            projectIdx: selectedProject.value.projectIdx,
            month: selectedMonth.value
        })
        return {
            selectedProject,
            selectedMonth
        }
    },
    beforeRouteEnter (to, from, next) {
        if (!(STORE_KEY in store._modules.root._children)) {
            store.registerModule(STORE_KEY, CloudFrontStore)
        }
        next()
    }
}
</script>

<style>

</style>
